module.exports = __webpack_public_path__ + "img/jm03_ks.d7455c18.png";